<template>
  <p class="Dateline">{{ dateString }}</p>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
    },
  },
  computed: {
    dateString() {
      const date = new Date(this.date)
      return date.toLocaleDateString(this.locale, { dateStyle: 'long', timeZone: 'UTC' })
    },
  },
}
</script>
